<template>
  <div class="alert-icon-wrapper">
    <DpplSvg
      :file-name="icon"
      :color="color"
    />
  </div>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'AlertIcon',
  components: { DpplSvg },
  props: {
    type: { type: String, default: '' },
    color: { type: String, default: '' },
  },
  computed: {
    icon() {
      return {
        error: 'icon-close',
        success: 'icon-check',
        info: 'icon-exclamation',
        warning: 'icon-exclamation',
      }[this.type || 'info'];
    },
  },
};
</script>

<style lang="less" scoped>
  .alert-icon-wrapper {
    flex-shrink: 0;
    background-color: @white;
    border-radius: 12px;
    width: 20px;
    height: 20px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
